<div [formGroup]="form" class="container-user-password-reset">
  <article *ngIf="formStatus == 'success'" class="message is-success">
    <div class="message-body">
      Das Passwort wurde erfolgreich gespeichert. Sie können sich nun mit Ihrem Benutzernamen sowie dem neu vergebenen Passwort <a routerLink="/user/login">einloggen</a>.
    </div>
  </article>

  <article *ngIf="!isToken" class="message is-danger">
    <div class="message-body">
      Der übergebene Token ist leider ungültig oder abgelaufen. Bitte lassen Sie sich einen neuen zukommen. Für Rückfragen stehen wir Ihnen gerne zur Verfügung.
    </div>
  </article>

  <div *ngIf="formStatus !== 'success' && isToken">
    <article class="message">
      <div class="message-body">
        Nachfolgend können Sie ein neues Passwort für Ihren Account setzen:
      </div>
    </article>
    <div class="field mt-4">
      <label class="label">Ihr neues Passwort*</label>
      <div class="control">
        <input formControlName="password" class="input" type="password" formControlName="password"
               placeholder="Passwort"/>
      </div>
    </div>
    <div class="field mt-4">
      <label class="label">Ihr neues Passwort (wiederholen)*</label>
      <div class="control">
        <input class="input" (keydown.enter)="submit()" type="password" formControlName="passwordRetype"
               placeholder="Passwort wiederholen"/>
        <p *ngIf="error.length > 0" class="help is-danger">{{error}}</p>
      </div>
    </div>
    <div class="mt-4 container-button">
      <iw-shop-forms-submit-button  [formStatus]="formStatus" [classes]="buttonClass" submitLabel="Passwort speichern"
                                  (submit)="submit()"></iw-shop-forms-submit-button >
    </div>
  </div>
</div>
